export default __webpack_public_path__ + "static/figma-components-49a813d25d89f1f9b3ba6a5163a606f8.gif";